import { gql } from '@apollo/client';

export const OTHER_PREVIEW_QUERY = gql`
  query contentQuery(
    $exclude: [Int]
    $postCategory: [String]
    $propertyType: [String]
    $locationDistrictId: [Int]
  ) {
    otherPreview: recommendation(
      request: {
        custom: {
          postCategory: $postCategory
          locationDistrictId: $locationDistrictId
        }
        propertyType: $propertyType
        perPage: 3
        exclude: $exclude
      }
    ) {
      id
      title
      date
      author {
        id
        name
        nickname
      }
      tags {
        name
      }
      postCategory
      link
      videoType
      propertyType
      featuredImage {
        url
        title
        width
        height
      }
      totalComments
      project {
        id
        name
        propertyType
        developer
        location {
          zone {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          district {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
          road {
            label
            value
            link
            parent {
              value
              label
              link
            }
          }
        }
        transportations {
          value
          label
          link
        }
        priceTypes {
          starting_price
          level {
            value
            label
          }
        }
      }
    }
  }
`;
